import { Injectable } from '@angular/core';
import { Router, CanLoad } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { FirebaseProvider } from 'src/provider/firebase';

@Injectable({
  providedIn: 'root'
})
export class AuthLoginGuard implements CanLoad {
  constructor(private firebase: FirebaseProvider, private router: Router) { }
  canLoad(): Observable<boolean> {
    return this.firebase.loggedIn.pipe(
      filter(val => val != null),
      take(1),
      map(isLogged => {
        if (isLogged) {
          this.router.navigateByUrl('/home',{ replaceUrl: true});
        } else {
          return true;
        }
      })
    )
  }
  
}
